import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import { PriceZoneCode, zoneSiteScopeText, zoneSitesListText } from '../priceZone';

/** 价区站点范围文本（对齐 perseus ZoneSiteScope）：LATAM 摘要后附 ⓘ，悬浮展示完整站点清单 */
export const ZoneScopeText = ({ zone }: { zone: PriceZoneCode }) => {
  const { t } = useTranslate();
  const getRegionLabel = useGetRegionLabel();

  return (
    <>
      {zoneSiteScopeText(zone, t, getRegionLabel)}
      {zone === 'LATAM' ? (
        <Tooltip title={zoneSitesListText(zone, getRegionLabel)}>
          <InfoCircleOutlined className="ml-[4px] cursor-pointer" />
        </Tooltip>
      ) : null}
    </>
  );
};
